import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useTrialWelcomePage = () => {
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState<'starter' | 'professional' | 'enterprise' | null>(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleStartTrial = async () => {
    if (!selectedPlan) return;

    setIsProcessing(true);
    
    try {
      // Save selected plan to localStorage for payment page
      localStorage.setItem('selectedPlan', selectedPlan);
      
      // Navigate to trial payment page
      navigate('/trial-payment');
    } catch (error) {
      console.error('Error starting trial:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  return {
    navigate,
    handleStartTrial: handleStartTrial,
    isCreatingAccount: isProcessing,
    selectedPlan,
    setSelectedPlan,
  };
};
